import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

/**
 * Interceptor that adds the authentication header to request
 */
@Injectable()
export class RouteInterceptor implements HttpInterceptor {
  /**
   * Intercepts the request and adds the authentication header
   * @param {HttpRequest<any>} req Request
   * @param {HttpHandler}      next HttpHandler
   * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.charAt(0) === '$') {
      // Add backend url and remove '$' sign
      const routeReq = req.clone({
        url: environment.backendUrl + 'api/' + req.url.substring(1),
      });

      return next.handle(routeReq);
    }

    // If it's another request (like i18n-JSON) pass original request
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/route.interceptor.ts